import React from "react";
import { Link } from "react-router-dom";
import { appData } from "../../landing/data";
import shape1 from "../../assets/images/shape-1.webp";
import shape2 from "../../assets/images/shape-2.webp";
import shape3 from "../../assets/images/shape-3.webp";
import shape4 from "../../assets/images/shape-4.webp";

export default function Pricings() {
  return (
    <section id="pricing" className="relative">
      <div className="w-full h4-pricing-wrapper pt-12 md:pt-20 pricing_section_bg">
        <div className="mx-auto theme-container">
          <div className="w-full">
            <div className="flex justify-center w-full title-area">
              <div className="flex flex-col items-center">
                <div className="mb-5 section-title-top-tag-two">
                  <span>Pricing</span>
                </div>
                <div className="mb-10 md:mb-[60px]">
                  <h2 className="font-semibold text-24 sm:text-48 text-center max-w-[819px]">
                    Our Pricing Packages
                  </h2>
                </div>
              </div>
            </div>
            <div className="w-full grid grid-cols-4 md:grid-cols-8 lg:grid-cols-12 gap-[30px]">
              {appData.pricing.map((pricing, index) => (
                <div
                  key={index}
                  className="col-span-4 bg-blue-sass rounded-xl p-7 md:p-[50px] price_card_bg transition-all duration-300"
                >
                  <h1 className="pb-4 font-semibold text-white text-18">
                    {pricing.title}
                  </h1>
                  <h2 className="text-white text-48">
                    <p>{pricing.price}</p>
                    <p className="text-lg leading-[30px] text-end">
                      {index !== 0 ? "/ bike / month" : "/ month"}
                    </p>
                  </h2>
                  <p className="pt-4 pb-8 text-white h-20">
                    {pricing.description}
                  </p>
                  <Link to="/" className="">
                    <div className="group bg-white w-full h-11 md:h-[56px] flex justify-center items-center gap-2.5 rounded-[40px] relative price_button_bg before:inline-block before:absolute before:w-full before:h-full before:scale-x-0 hover:before:scale-x-100 overflow-hidden before:transition-transform before:ease-out before:duration-300 before:origin-right hover:before:origin-left before:z-0">
                      <span className="relative z-10 font-semibold transition-all duration-300 font-inter text-blue-sass group-hover:text-white">
                        Choose This Package
                      </span>
                      <svg
                        className="relative z-10"
                        width="7"
                        height="12"
                        viewBox="0 0 7 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          className="transition-all duration-300 group-hover:stroke-white"
                          d="M1 10.5L4.79289 6.70711C5.12623 6.37377 5.29289 6.20711 5.29289 6C5.29289 5.79289 5.12623 5.62623 4.79289 5.29289L1 1.5"
                          stroke="#fffff"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  </Link>
                  <ul className="flex flex-col gap-4 mt-9">
                    {pricing.features.map((feature, index) => (
                      <li key={index} className="flex items-center gap-3">
                        <svg
                          width="20"
                          height="15"
                          viewBox="0 0 20 15"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M19.1035 0.411506C18.9741 0.281114 18.8203 0.177618 18.6507 0.10699C18.4812 0.0363625 18.2994 0 18.1157 0C17.9321 0 17.7502 0.0363625 17.5807 0.10699C17.4112 0.177618 17.2573 0.281114 17.128 0.411506L6.76377 10.7897L2.4094 6.42137C2.27512 6.29166 2.11661 6.18967 1.94292 6.12122C1.76922 6.05276 1.58375 6.0192 1.39708 6.02243C1.21041 6.02565 1.0262 6.06562 0.854981 6.14004C0.683758 6.21446 0.528869 6.32187 0.399158 6.45615C0.269447 6.59043 0.167455 6.74894 0.099004 6.92264C0.0305528 7.09633 -0.00301682 7.28181 0.000212736 7.46847C0.00344229 7.65514 0.0434076 7.83935 0.117826 8.01057C0.192245 8.18179 0.29966 8.33668 0.433938 8.46639L5.77604 13.8085C5.90537 13.9389 6.05923 14.0424 6.22876 14.113C6.39829 14.1836 6.58012 14.22 6.76377 14.22C6.94742 14.22 7.12926 14.1836 7.29878 14.113C7.46831 14.0424 7.62218 13.9389 7.7515 13.8085L19.1035 2.45653C19.2447 2.32626 19.3574 2.16815 19.4345 1.99217C19.5115 1.81618 19.5513 1.62614 19.5513 1.43402C19.5513 1.24189 19.5115 1.05185 19.4345 0.875871C19.3574 0.699888 19.2447 0.541779 19.1035 0.411506Z"
                            fill="#FFF"
                          />
                        </svg>
                        <span className="font-medium text-white sm:text-18">
                          {feature}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="absolute z-10 shape-1 left-40 top-96">
          <img src={shape1} alt="" />
        </div>
        <div className="absolute z-10 shape-2 right-96 top-96">
          <img src={shape2} alt="" />
        </div>
        <div className="shape-3 absolute left-96 top-[550px] z-10">
          <img src={shape3} alt="" />
        </div>
        <div className="shape-4 absolute right-96 top-[550px] z-10">
          <img src={shape4} alt="" />
        </div>
      </div>
    </section>
  );
}
